import QueryResult from "@/components/QueryResult/query-result";
import { useAvailableContactMethodsQuery, useGetBookingTimesQuery, useGetSpecialtiesQuery } from "@/graphql/graphql";
import { useAppSelector } from "@/redux/hooks";
import { selectHomepage } from "@/redux/state/homepage";
import React from "react";
import {
  CardBody,
  Collapse, Container,
  Row
} from "reactstrap";
import BookingRangeCard from "./Cards/BookingRangeCard";
import BookingTimeCard, { NoBookings } from "./Cards/BookingTimeCard";
import ContactMethodCard from "./Cards/ContactMethodCard";
import SpecialtyCard from "./Cards/SpecialtyCard";
import "./PickService.scss";
import PickServiceContainer from "./PickServiceContainer";

function PickService() {
  const { openModals: { specialty, contactMethod, bookingTime } } = useAppSelector(selectHomepage)
  const { data: specialtyData, loading: specialtyLoading, error: specialtyError } = useGetSpecialtiesQuery();
  const { data: contactMethodData, loading: contactMethodLoading, error: contactMethodError } = useAvailableContactMethodsQuery();
  const { data: bookingData, loading: bookingLoading, error: bookingError } = useGetBookingTimesQuery();

  return (
    <PickServiceContainer styleId="pick-service">
      <Collapse isOpen={specialty}>
        <CardBody style={{ paddingTop: 0 }}>
          <Container>
            <Row xs="1" sm="1" md="3">
              <QueryResult loading={specialtyLoading} error={specialtyError} data={specialtyData}>
                {specialtyData?.specialtiesForHome &&
                  specialtyData.specialtiesForHome.map((specialty: any, index: number) => (
                    <SpecialtyCard key={index} specialty={specialty} />
                  ))}
              </QueryResult>
            </Row>
          </Container>
        </CardBody>
      </Collapse>
      <Collapse isOpen={contactMethod}>
        <CardBody style={{ paddingTop: 0 }}>
          <Container>
            <Row xs="1" sm="1" md="3">
              <QueryResult loading={contactMethodLoading} error={contactMethodError} data={contactMethodData}>
                {contactMethodData &&
                  contactMethodData.availableContactMethods.map((contactMethod, index) => <ContactMethodCard key={index} method={contactMethod} />)}
              </QueryResult>
            </Row>
          </Container>
        </CardBody>
      </Collapse>
      <Collapse isOpen={bookingTime}>
        <CardBody style={{ paddingTop: 0 }}>
          <Container>
            <Row color="black">
            <Row xs="1" sm="1" md="3">
              <QueryResult loading={bookingLoading} error={bookingError} data={bookingData}>
                {bookingData && bookingData.availableTimes && bookingData.availableTimes.length > 0 ? <BookingTimeCard data={bookingData} /> : <NoBookings />}
              </QueryResult>
              {/* <BookingRangeCard /> */}
            </Row>
            </Row>
          </Container>
        </CardBody>
      </Collapse>
    </PickServiceContainer>
  );
}

// const BookingTime = () => {
//   return (<Datetime input={false} />)
// };

export default PickService;
